import ContentError from 'components/ContentError'
import ContentLoading from 'components/ContentLoading'
import {
  DropdownItem,
  DropdownItemDescription,
  DropdownItemTitle,
  DropdownScroll,
} from 'components/Dropdown'
import Icon from 'components/Icon'
import { useBrandingSettings } from 'hooks/branding'
import { useActivation } from 'hooks/mobx-hooks'
import { observer } from 'mobx-react'
import React from 'react'
import { FilterSearchBar, FilterViewHeader } from '..'
import { SingleSelectFilter } from './SingleSelectFilter'

interface SingleSelectFilterViewProps<
  TFilters extends Record<string, unknown>,
> {
  filter: SingleSelectFilter<keyof TFilters, any>
}

export const SingleSelectFilterView = observer(function SingleSelectFilterView<
  TFilters extends Record<string, unknown>,
>({ filter }: SingleSelectFilterViewProps<TFilters>) {
  const branding = useBrandingSettings()
  const searchEnabled = filter.options.length >= 5
  useActivation(filter)

  return (
    <>
      <FilterViewHeader
        title={filter.title}
        dataTest={'single-select-filter-clear-button'}
        onClear={() => {
          filter.clearValue()
          filter.stopEditing()
        }}
      />
      {searchEnabled && (
        <FilterSearchBar
          onChange={(text) => filter.changeSearchText(text.toLowerCase())}
        />
      )}
      <DropdownScroll>
        {filter.loadOptions.match({
          pending: () => <ContentLoading compact />,
          rejected: (err: any) => <ContentError error={err} />,
          resolved: () =>
            filter.searchFilterOptions.map((c, index) => (
              <DropdownItem
                key={`${c.title}-${index}`}
                data-test={'single-select-filter-option-' + c.title}
                onClick={() => filter.change(c.value)}
                icon={
                  <Icon
                    color={branding.themePrimary}
                    name={
                      filter.isSelected(c.value) ? 'checkbox' : 'checkbox-blank'
                    }
                  />
                }
              >
                <DropdownItemTitle>{c.title}</DropdownItemTitle>
                <DropdownItemDescription>
                  {c.description}
                </DropdownItemDescription>
              </DropdownItem>
            )),
        })}
      </DropdownScroll>
    </>
  )
})
